import styled from 'styled-components';

export const InputActionContent = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
  min-height: 32px;
  transition: all 0.2s;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: ${({ theme }) => theme.radius.small}px;

  &:hover {
    background-color: ${({ theme }) => theme.color.state.focused};
  }

  .on-dark &:hover {
    background-color: ${({ theme }) => theme.color.state.focusedDark};
  }

  :active {
    opacity: 0.2;
    background-color: ${({ theme }) => theme.color.state.focused};
  }

  .on-dark &:active {
    opacity: 0.2;
    background-color: ${({ theme }) => theme.color.state.focusedDark};
  }

  :focus {
    outline: none;
  }
`;

export const InputActionSC = styled.button`
  width: 36px;
  min-width: 36px;
  height: 36px;
  min-height: 36px;

  outline: none;
  border: none;
  background: none;
  transition: all 0.2s;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  :focus {
    outline: none;
  }

  :disabled {
    cursor: not-allowed;

    ${InputActionContent} {
      pointer-events: none;
      cursor: not-allowed;
      :hover {
        background-color: transparent;
      }
    }
  }
`;
